import { create } from 'zustand';

type DrawerMode = 'full' | 'compact';

interface OutlookDrawerState {
  isOpen: boolean;
  mode: DrawerMode;

  open: () => void;
  close: () => void;
  toggle: () => void;
  setMode: (mode: DrawerMode) => void;
}

const STORAGE_KEY = 'outlook_drawer_mode';

function getStoredMode(): DrawerMode {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'full' || stored === 'compact') return stored;
  } catch {}
  return 'compact';
}

export const useOutlookDrawerStore = create<OutlookDrawerState>((set) => ({
  isOpen: false,
  mode: getStoredMode(),

  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((s) => ({ isOpen: !s.isOpen })),

  setMode: (mode) => {
    localStorage.setItem(STORAGE_KEY, mode);
    set({ mode });
  },
}));
